import { Typography } from "antd";
import { EmptyString } from "constants/strings";
import { useEffect, useState } from "react";

let version: { version: string } | null = null;

export const VersionInfo = () => {
  const [info, setInfo] = useState<{ version: string } | null>(version);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    const getVersion = async () => {
      if (isLoading) return;
      setLoading(true);
      try {
        const response = await fetch("/build.json");
        const data = await response.json();
        version = data;
        setInfo(data);
      } catch (error) {
        console.error("Failed to fetch build info:", error);
        version = null;
        setInfo(null);
      } finally {
        setLoading(false);
      }
    };

    if (!version) {
      getVersion();
    }
  }, []);

  if (!info) return null;

  return <Typography.Text type="secondary">Версия платформы: {info.version ?? EmptyString}</Typography.Text>;
};
